export default __webpack_public_path__ + "static/media/gallery8.850a1482.jpg";